<template>
  <lms-layout :actions="actions" :showBackButton="showBackButton" :backButtonClick="backButtonClick"
              @toolbarClick="handleClick">
    <template slot="t-body">
      <div class="lms-filter-content">
        <slot name='t-search'>
        </slot>
      </div>
      <div class="m-t">
        <slot name="t-body">

        </slot>
      </div>
    </template>
  </lms-layout>
</template>
<script>
  import subLayout from './subLayout'
  export default {
    mixins: [subLayout],
    name: 'lms-list-layout',
  }
</script>
<style lang="less">
  .lms-filter-content {
    .ivu-form-item {
      margin-bottom: 0px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// ListLayout.vue?ba4e0142